import { useCallback, useEffect } from 'react';

import { useStore } from 'react-admin';

export function useResetExpandedGatewayRules() {
  const [, setExpandAll] = useStore<boolean>('gateway_rules.datagrid.view');
  const [, setExpandedIds] = useStore<string[]>('gateway_rules.datagrid.expanded');

  const resetExpandedRules = useCallback(() => {
    setExpandedIds([]);
    setExpandAll(false);
  }, []);

  useEffect(() => {
    resetExpandedRules();
  }, []);

  return { resetExpandedRules };
}
